import { format, subDays, subMonths, subYears } from "date-fns";

export function dayMonthDate(date) {
  return format(new Date(date), "EE, MMM dd");
}

export function yearMonthDate(date) {
  return format(new Date(date), "yyyy-MM-dd");
}

export function subtractMonth(date, months) {
  return subMonths(date, months);
}

export function subtractDays(date, days) {
  return subDays(date, days);
}

export function subtractYears(date, years) {
  return subYears(date, years);
}
